import { useEffect, useState } from 'react';
import { Dispatch, bindActionCreators } from 'redux';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { RootState } from '../../reducers';
import * as actions from '../../actions/generalActions';
import { axiosCaller } from '../../utils/apiCaller';
import { toast } from 'react-toastify';
import { t } from '../../i18n';
import MikaConfirmModal from '../../components/MikaConfirmModal/MikaConfirmModal';
import './offerSettings.scss';

interface ServiceType {
    id: number;
    name: string;
    is_default: boolean;
    is_protected: boolean;
    sort_order: number;
}

interface Props {
    actions: any;
    buttonLoader: boolean;
}

var ServicingTypes = function(props: Props) {
    var intl = useIntl();
    var fm = function(id: string, defaultMessage: string) { return intl.formatMessage({ id: id, defaultMessage: defaultMessage }); };
    var _t = useState<ServiceType[]>([]); var types = _t[0]; var setTypes = _t[1];
    var _n = useState(''); var newName = _n[0]; var setNewName = _n[1];
    var _ei = useState<number | null>(null); var editingId = _ei[0]; var setEditingId = _ei[1];
    var _en = useState(''); var editingName = _en[0]; var setEditingName = _en[1];
    var _l = useState(true); var loading = _l[0]; var setLoading = _l[1];
    var _dc = useState<ServiceType | null>(null); var deleteConfirm = _dc[0]; var setDeleteConfirm = _dc[1];

    useEffect(function() { loadTypes(); }, []);

    var loadTypes = function() {
        setLoading(true);
        axiosCaller('GET', 'servicing-types').then(function(res: any) {
            setTypes(res?.data || []);
            setLoading(false);
        }).catch(function() { setLoading(false); });
    };

    var addType = function() {
        if (!newName.trim()) { toast.error(t('admin.servicingTypes.toastFillName')); return; }
        axiosCaller('POST', 'admin/servicing-types', { name: newName.trim() }).then(function() {
            toast.success(t('admin.servicingTypes.toastAdded'));
            setNewName('');
            loadTypes();
        }).catch(function() { toast.error(t('admin.toast.somethingWentWrong')); });
    };

    var startEdit = function(typeRow: ServiceType) {
        setEditingId(typeRow.id);
        setEditingName(typeRow.name);
    };

    var saveEdit = function() {
        if (!editingName.trim()) { toast.error(t('admin.servicingTypes.toastNameEmpty')); return; }
        axiosCaller('PATCH', 'admin/servicing-types/' + editingId, { name: editingName.trim() }).then(function() {
            toast.success(t('admin.servicingTypes.toastUpdated'));
            setEditingId(null); setEditingName('');
            loadTypes();
        }).catch(function() { toast.error(t('admin.toast.somethingWentWrong')); });
    };

    var executeDelete = function() {
        if (!deleteConfirm) return;
        axiosCaller('DELETE', 'admin/servicing-types/' + deleteConfirm.id).then(function() {
            toast.success(t('admin.servicingTypes.toastDeleted'));
            setDeleteConfirm(null);
            loadTypes();
        }).catch(function(err: any) {
            toast.error(err?.response?.data?.message || t('admin.toast.somethingWentWrong'));
            setDeleteConfirm(null);
        });
    };

    return (
        <div style={{ padding: 20, width: '100%' }}>
            <div className="os-page">
                <div className="os-page-header">
                    <div>
                        <h1 className="os-page-title"><FormattedMessage id="admin.servicingTypes.pageTitle" defaultMessage="Llojet e servisimit" /></h1>
                        <p className="os-page-subtitle"><FormattedMessage id="admin.servicingTypes.pageSubtitle" defaultMessage="Menaxhoni llojet që përdoren kur krijohet një servisim i ri" /></p>
                    </div>
                </div>

                <div className="os-card">
                    <div className="os-card-header">
                        <div>
                            <h2><FormattedMessage id="admin.servicingTypes.cardTitle" defaultMessage="Llojet" /></h2>
                            <p className="os-card-desc"><FormattedMessage id="admin.servicingTypes.cardDesc" defaultMessage="Këto lloje shfaqen si opsion kur krijohet një servisim" /></p>
                        </div>
                    </div>
                    <div className="os-card-body">
                        {loading ? (
                            <p className="os-empty-text"><FormattedMessage id="common.loading" defaultMessage="Duke ngarkuar..." /></p>
                        ) : (
                            <>
                                <div className="os-field-pills">
                                    {types.map(function(t) {
                                        return (
                                            <div key={t.id} className="os-field-pill">
                                                {editingId === t.id ? (
                                                    <div className="os-pill-edit">
                                                        <input type="text" value={editingName}
                                                            onChange={function(e) { setEditingName(e.target.value); }}
                                                            onKeyDown={function(e) { if (e.key === 'Enter') saveEdit(); }}
                                                            autoFocus />
                                                        <button type="button" className="os-pill-action save" onClick={saveEdit} title={fm('common.action.save', 'Ruaj')}>
                                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                                                        </button>
                                                        <button type="button" className="os-pill-action cancel" onClick={function() { setEditingId(null); }} title={fm('common.action.cancel', 'Anulo')}>
                                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <span className="os-pill-name">
                                                            {t.name}
                                                            {t.is_default && <span style={{ fontSize: 9, color: '#94a3b8', marginLeft: 4, fontWeight: 400 }}><FormattedMessage id="admin.servicingTypes.defaultBadge" defaultMessage="(default)" /></span>}
                                                        </span>
                                                        <button type="button" className="os-pill-action edit" onClick={function() { startEdit(t); }} title={fm('common.action.edit', 'Ndrysho')}>
                                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                                                        </button>
                                                        {!t.is_protected && (
                                                            <button type="button" className="os-pill-action delete" onClick={function() { setDeleteConfirm(t); }} title={fm('common.action.delete', 'Fshi')}>
                                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                                                            </button>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>

                                <div className="os-add-field">
                                    <input type="text" value={newName}
                                        onChange={function(e) { setNewName(e.target.value); }}
                                        placeholder={fm('admin.servicingTypes.placeholder', 'Emri i llojit të ri...')}
                                        onKeyDown={function(e) { if (e.key === 'Enter') addType(); }} />
                                    <button type="button" className="os-add-btn" onClick={addType} disabled={!newName.trim()}>
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                                        <FormattedMessage id="admin.servicingTypes.btnAdd" defaultMessage="Shto" />
                                    </button>
                                </div>

                                {types.length === 0 && (
                                    <p className="os-empty-text"><FormattedMessage id="admin.servicingTypes.empty" defaultMessage="Nuk ka lloje. Shtoni llojin e parë." /></p>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>

            <MikaConfirmModal
                isOpen={!!deleteConfirm}
                onClose={function() { setDeleteConfirm(null); }}
                onConfirm={executeDelete}
                title={fm('admin.servicingTypes.deleteTitle', 'Fshi llojin')}
                message={intl.formatMessage(
                    { id: 'admin.servicingTypes.deleteConfirm', defaultMessage: 'A jeni të sigurt që doni të fshini {name}?' },
                    { name: '"' + (deleteConfirm?.name || '') + '"' }
                )}
                confirmLabel={fm('common.action.delete', 'Fshi')}
                confirmColor="danger"
            />
        </div>
    );
};

function mapStateToProps(state: RootState, ownProps: any) {
    return { ...ownProps, ...state.app };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
    return {
        actions: bindActionCreators(actions as any, dispatch),
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(ServicingTypes as any)));
